angular.module('impactx.search').component('ixLotItemActions', {
        bindings: {
            lot: '<'
        },
        controller: 'LotItemActionCtrl',
        controllerAs: 'actionsCtrl',
        templateUrl: 'modules/search/templates/lot-item-actions.html'
    }
);